import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './Error.css';

const Error = ({ error }) => {
	const { t } = useTranslation();

	return (
		<div className='Error'>
            {t(error)}
		</div>
	);
};

Error.propTypes = {
    error: PropTypes.string.isRequired,
};

export default Error;
